import React from 'react'
import './index.less'

export default function DeviceWarningInfoItem({
  warningInfo = {},
}) {
  return (
    <div className={`device-warning-info-Item device-warning-level-${warningInfo.level}`}>
      <div className="dv-title">
        <span className="dv-main-title">{warningInfo.hname}</span>
        <span className="dv-sub-title">来源</span>
      </div>
      <div className="dv-con">
        {warningInfo.msg}
      </div>
    </div>
  )
}